<template>
  <div class="RealTimeQuality">

    <ul>
      <li v-for="(item, index) in memberList" :key="index" class="_item" :class="{ activeTab: active === index }"
        @click="activeTab(index)">
        <div class="title"> {{ item.userName}} </div>
        <div class="name"> {{ item.pushUid }} </div>

      </li>
    </ul>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="帧率" name="Frame"></el-tab-pane>
      <el-tab-pane label="码率" name="Code"></el-tab-pane>
      <el-tab-pane label="丢包率" name="Packet"></el-tab-pane>
      <el-tab-pane label="时延" name="delay"></el-tab-pane>
    </el-tabs>
    <div id="echart"></div>
  </div>
</template>

<script>
import {getDwSdkCastDeskMemberListApi, getSdkCastShareReceiveListApi } from "@/api/imageManagement";

import * as echarts from 'echarts';
export default {
  data() {
    return {
      logCreateTime: '暂无',
      active: 0,
      myChart: '',
      activeName: 'Frame',
      Frame: {}, //帧率
      Code: {}, //码率
      Packet: {},//丢包率
      delay: {},//时延
      memberList:[],
      userId:''
    }
  },
  props: {
    uid: {
      type: String,
      default: ''
    },
  },
  mounted() {
    this.getMemberList()
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById('echart'));
  },

  methods: {
    // 获取成员LIST
    async getMemberList() {
      let res = await getDwSdkCastDeskMemberListApi({ roomId: this.$route.query.roomid })
      this.memberList = res.data.data
      this.userId = this.memberList.length ? this.memberList[0].pushUid : ''
      this.active = 0
      this.init()
    },

    // 人员tab切换
    activeTab(i) {
      this.active = i
      this.userId = this.memberList[i].pushUid
      this.init()
    },
    //时间戳转换
    formatDate(date, fmt) {
      let o = {
        'M+': date.getMonth() + 1,                    //月份
        'd+': date.getDate(),                        //日
        'h+': date.getHours(),                       //小时
        'm+': date.getMinutes(),                     //分
        's+': date.getSeconds(),                     //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()                 //毫秒
      };
      if (/(y+)/.test(fmt)) {   //年份
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          let str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length);
    },
    // 设置图表
    echartsSet(legendList, xAxisList, seriesData) {
      let eriesList = legendList.map((item) => {
        return {
          data: seriesData[item.data],
          type: 'line',
          name: item.name
        }
      })
      let legendData = legendList.map((item) => { return item.name })
      let xAxisData = xAxisList.map(item => { return this.formatDate(new Date(+item), 'hh:mm') })//时间线  'yyyy-MM-dd hh:mm'
      // 绘制图表
      this.myChart.setOption(
        {
          dataZoom: [{
            type: 'inside', //1平移 缩放
            throttle: '50', //设置触发视图刷新的频率。单位为毫秒（ms）。
            minValueSpan: 6, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
            start: 1, //数据窗口范围的起始百分比 范围是：0 ~ 100。表示 0% ~ 100%。
            end: 50, //数据窗口范围的结束百分比。范围是：0 ~ 100。
            zoomLock: true, //如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放。
          }],
          // 主要用来控制图表四周留白
          grid: {
            left: '5%',
            top: '15%',
            right: '5%',
            bottom: '15%',
          },

          legend: {
            data: legendData //表头
          },
          xAxis: {
            data: xAxisData
          },
          tooltip: {},
          yAxis: {},
          series: eriesList
        }, true
      );
    },
    //点击切换图表数据
    handleClick() {
      this.echartsSet(this[this.activeName].legendList, this.timeLine.localTimestamp, this[this.activeName])
    },
    // 获得全部图表数据
    async init() {
      this.activeName = 'Frame'
      let params = {
        roomId:this.$route.query.roomid,
        code: this.$route.query.code,
        uid: this.userId,
        current: 1,
        size: -1,
      }
      if(!params.code) return
      try {
        let data = await getSdkCastShareReceiveListApi(params)

        let list = data.data.data.records
        // 分成7份数据，对应6个table和一个时间线
        this.Frame = {
          legendList: [{ name: '屏幕分享拉流帧率', data: 'receiveVideoFps' }],
          receiveVideoFps: [],//屏幕分享拉流帧率
        }, //帧率
          this.Code = {
            legendList: [{ name: '屏幕分享拉流码率', data: 'receiveVideoRate' }],
            receiveVideoRate: [], //屏幕分享拉流码率
          }, //码率
          this.Packet = {
            legendList: [{ name: '丢包率', data: 'loss' }],
            loss: [], //丢包率
          },//丢包率
          this.delay = {
            legendList: [{ name: '屏幕分享拉流延时', data: 'receiveVideoRtt' }],
            receiveVideoRtt: [], //屏幕分享拉流延时
          },//时延
    
          this.timeLine = { localTimestamp: [] }//时间戳
        // 排序
        list = list.sort((a, b) => {
          return a.localTimestamp - b.localTimestamp
        })
        list.forEach((item) => {
          this.Frame.receiveVideoFps.push(item.receiveVideoFps)
          this.Code.receiveVideoRate.push(item.receiveVideoRate)
          this.Packet.loss.push(item.loss)
          this.delay.receiveVideoRtt.push(item.receiveVideoRtt)
          this.timeLine.localTimestamp.push(item.localTimestamp)
        })
        //默认
        this.echartsSet(this.Frame.legendList, this.timeLine.localTimestamp, this.Frame)

      } catch (err) {
        console.log(err)
      }
    }

  }
}
</script>
<style  lang="scss" scoped>
.RealTimeQuality {
  margin-top: -25px;
  .Escalation {
    text-align: right;

    .time {
      margin-right: 15px;
      color: #6A6565 100%;
      font-size: 14px;
      font-family: SourceHanSansSC-regular;
    }
  }

  #echart {
    width: 100%;
    height: 306px;
    background-color: #f8f6f6;
    padding-top: 34px;
  }
}

ul {
  display: flex;
  flex-wrap: wrap;

  ._item {
    list-style-type: none;
    width: 220px;
    text-align: center;
    background-color: #c5c5c5;
    padding: 15px;
    margin: 15px 15px 0 0;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;

    .title {
      font-size: 16px;
    }
  }

  .activeTab {
    background-color: #31a3f3;
    color: #fff;
  }
}

/deep/.el-tabs__nav-wrap::after {
  background-color: #fff !important;
}</style>